<template>
  <div class="evidence-category-card__patient-id">
    <label :for="inputId" class="evidence-category-card__patient-id-label">
      {{ $t('app.assessment_mode.text.input.patient_id_label') }}
    </label>
    <input
        :id="inputId"
        :value="value"
        type="text"
        class="evidence-category-card__patient-id-input"
        :placeholder="String($t('app.assessment_mode.text.input.patient_id_placeholder'))"
        @input="handleInput"
        @change="$emit('change')"
    />
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'PatientIdField',

  props: {
    inputId: {
      type: String,
      required: true,
    },
    value: {
      type: String,
      default: '',
    },
  },

  setup(_, { emit }) {
    const handleInput = (event: Event): void => {
      emit('input', (event.target as HTMLInputElement).value);
    };

    return {
      handleInput,
    };
  },
});
</script>
